export default __webpack_public_path__ + "static/media/img3.929dbc24.png";